import { Card, Box, Typography, Grid } from "@material-ui/core";
import { useState } from "react";
import { useSelector } from "react-redux";
import CustomPagination from "../../../constants/CustomPagination";
import { url } from "../../../constants";

const BrandCard = (props) => {
  const [name, setName] = useState(null);
  const brand = props.brand;
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  return (
    <div>
      <Card
        style={{
          width: isDesktopOrLaptop ? "147px" : "100%",
          height: isDesktopOrLaptop ? "172px" : "185px",
          borderRadius: "10px",
          boxShadow: "0 0 11px 0 #16063b26",
          backgroundColor: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {brand?.image_name == "False" || name ? (
          <Typography style={{ fontFamily: "Overpass", textAlign: "center" }}>
            {brand?.brand_name}
          </Typography>
        ) : (
          <img
            src={`${url}/static/Brands/${brand?.image_name}`}
            width="130px"
            onError={() => {
              setName(brand?.brand_name);
            }}
          ></img>
        )}
      </Card>
    </div>
  );
};

const Brands = (props) => {
  const brands = props.data;
  const [page, setPage] = useState(1);
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);

  return (
    <>
      <Grid
        container
        style={{
          padding: isDesktopOrLaptop ? "54px 5px 0px 341px" : "7px 0px 0 26px",
        }}
      >
        <Box
          display={isDesktopOrLaptop ? "flex" : "unset"}
          flexWrap="wrap"
          style={{
            width: "850px",
            margin: 0,
            padding: 0,
          }}
        >
          {brands?.slice((page - 1) * 12, page * 12).map((brand) => {
            return (
              <div
                style={{
                  paddingRight: isDesktopOrLaptop ? "57px" : "24px",
                  paddingBottom: isDesktopOrLaptop ? "55px" : "25px",
                }}
              >
                <BrandCard brand={brand} />
              </div>
            );
          })}
        </Box>
      </Grid>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <CustomPagination
          page={page}
          totalPages={Math.ceil(brands?.length / 12)}
          setPage={setPage}
          margin={isDesktopOrLaptop ? "0px" : "10px"}
          marginBottom="25px"
        />
      </div>
    </>
  );
};

export default Brands;
